import * as React from "react";
import * as ReactDOM from "react-dom";
import { LocalizedStrings } from "react-localization";
import Router from "./router";
import { lang } from "./lang";
import { store } from "./store";
import { config, initStore, store as uiStore } from "./store/ui";
import { Loader } from "./components/molecules/Loader";

async function initComponents(data: { title?: string; language?: LocalizedStrings<string>; basePath?: string }) {
    await initStore();

    if (data.language) {
        lang.setLanguage(data.language);
    }
    if (data.basePath) {
        uiStore.basePath = data.basePath;
    }

    uiStore.title = data.title ?? uiStore.title;

    lang.setLanguage(store.language);
    Object.assign(config, data);

    const elementBody = document.querySelector<HTMLElement>("body");
    const language = store.language || "ja";

    if (elementBody) {
        elementBody.removeAttribute("class");
        elementBody.classList.add(language);
    }

    const elementHtml = document.querySelector<HTMLElement>("html");

    if (elementHtml) {
        elementHtml.setAttribute("lang", language);
    }
}

const initApp = async () => {
    // Prevents msal from sending callback to parent
    window.opener = null;
    await initComponents({
        basePath: uiStore.basePath,
        title: "KPMG Tax NBB"
    });

    // store.setShowNotice(false);

    // Render App
    ReactDOM.render(
        <>
            <Loader />
            <Router />
        </>,
        document.getElementById("app")
    );
};

initApp().catch((error: Error) => {
    store.doNotice(error.toString());
});
